export default __webpack_public_path__ + "static/media/egg-7.7c72085d.png";